import { useCallback, useContext } from 'react'
import { EPCRContext } from '../EPCR'
import { TenantSettingsContext, UserContext } from '../../../../App'

// The ePCR context plus `updateRecord(updater)`: applies a pure
// record -> record function (engine helpers) to formValues and marks the
// draft dirty exactly like handleChange does, so autosave picks it up.
// Build taps / ids OUTSIDE the updater - React may call it twice.
const useLiveRecord = () => {
  const context = useContext(EPCRContext)
  const { user } = useContext(UserContext)
  const orgSettings =
    useContext(TenantSettingsContext)?.orgConfig?.orgSettings ?? {}
  const { setFormValues, setUploadState, setIsDraftDirty } = context

  const updateRecord = useCallback(
    (updater) => {
      setUploadState((prev) => (prev === 'pending' ? prev : 'pending'))
      setFormValues((prev) => updater(prev))
      setIsDraftDirty(true)
    },
    [setFormValues, setUploadState, setIsDraftDirty],
  )

  return { ...context, user, orgSettings, updateRecord }
}

export default useLiveRecord
